<template>
    <section>
        <section class="info-container">
            <section class="info-item-wrap">
                <p class="info-title m-t-16">车辆信息</p>
                <a-row class="m-t-18">
                    <a-col :span="8">
                        <a-row class="info-item">
                            <a-col class="key">出入口名称</a-col>
                            <a-col class="val">{{doorwayDetails.doorwayName}}</a-col>
                        </a-row>
                    </a-col>
                    <a-col :span="16">
                        <a-row class="info-item">
                            <a-col class="key">关联设备</a-col>
                            <a-col class="val">
                                <a-row class="m-b-8" v-for="(item,key) in doorwayDetails.deviceList" :key="key">
                                    <span class="m-r-10">{{item.deviceName}}</span>
                                    <span style="color:rgba(255,255,255,0.8)">{{item.deviceNo}}</span>
                                </a-row>
                                
                            </a-col>
                        </a-row>
                    </a-col>
                </a-row>
                
            </section>

            <section class="info-item-wrap">
                <p class="info-title m-t-16">车辆信息</p>

                <section class="search-container m-b-18 m-t-16">
                    <a-form layout="inline" class="m-t-14">
                        <a-form-item label="进出时间" >
                            <a-range-picker class="search-range-date" v-model="searchInfo.dateArea"/>
                        </a-form-item>

                        <a-form-item>
                            <a-button @click="search" class="m-r-8"><a-icon type="search" />查询</a-button>
                            <a-button @click="reset"><a-icon type="reload" />重置</a-button>
                        </a-form-item>
                    </a-form>
                </section>

                <a-row class="m-b-18">
                    <span class="m-r-18">进入车辆数：{{carStatistical.carNumber || 0}}辆</span>
                    <span>车辆进入：{{carStatistical.inOutNumber || 0}}次</span>
                </a-row>
                <section class="list-table-container">
                    <a-table size="small" :columns="carInOutLog.columns" :data-source="carInOutLog.data" :pagination="{total:carInOutLog.total,hideOnSinglePage:true}" @change="changePageNum">
                        <span slot="carStatus" slot-scope="text">{{text === 0 ? '正常车辆' : '陌生车辆'}}</span>
                        <span slot="inOutType" slot-scope="text">{{text === 1 ? '进入工地' : '离开工地'}}</span>
                        <a-row slot="logImage" slot-scope="text">
                            <previewImage :data="text" :size="40" />
                        </a-row>
                    </a-table>
                </section>
            </section>
        </section>
    </section>
</template>

<script>
const columns = [
    {title:'序号',dataIndex:'key',align:'center',key:'key'},
    {title:'出入口名称',dataIndex:'doorwayName',align:'center',key:'doorwayName'},
    {title:'所属单位',dataIndex:'companyName',align:'center',key:'companyName'},
    {title:'车辆类型',dataIndex:'carTypeName',align:'center',key:'carTypeName'},
    {title:'车牌号',dataIndex:'carNumber',align:'center',key:'carNumber'},
    {title:'进出时间',dataIndex:'createTime',align:'center',key:'createTime'},
     {title:'进出状态',dataIndex:'inOutType',align:'center',key:'inOutType',scopedSlots:{customRender: "inOutType"}},
    {title:'标识',dataIndex:'carStatus',align:'center',key:'carStatus',scopedSlots:{customRender: "carStatus"}},
    {title:'通行图像',dataIndex:'logImage',align:'center',key:'logImage',scopedSlots:{customRender: "logImage"}}
]
// import moment from 'moment'
import previewImage from '@/components/previewImage'
export default {
    data(){
        return{
            
            doorwayDetails:{},
            carStatistical:{},
            searchInfo:{
                dateArea:[]
            },
            carInOutLog:{
                total:0,
                pageNum:1,
                columns,
                data:[]
            }

        }
    },
    components:{previewImage},
    computed:{
        cid(){
            return this.$route.query.id
        }
    },
    created(){
        this.queryCarInletOutletDetails()
    },
    methods:{
        queryCarInletOutletDetails(){
            let params = {
                id:this.cid,
                current:this.carInOutLog.pageNum,
                startDate:this.searchInfo.dateArea.length ? this.searchInfo.dateArea[0].format('YYYY-MM-DD') : '',
                endDate:this.searchInfo.dateArea.length ? this.searchInfo.dateArea[1].format('YYYY-MM-DD') : '',
            }
            this.$api.queryCarInletOutletDetails(params).then(res =>{
                if(res.code === 200){
                    this.doorwayDetails = (res.data && res.data.doorwayDetails) || {}
                    let carInOutLog = (res.data && res.data.carInOutLog) || {}
                    this.carStatistical = (res.data && res.data.carStatistical) || {}
                    this.carInOutLog.data= carInOutLog.records || []
                    this.carInOutLog.total= carInOutLog.total || 0
                    this.carInOutLog.data.forEach((item,ind) =>{
                        item.key = ind + 1
                    })
                    
                }
            })
        },
        reset(){
            this.searchInfo.dateArea = []
            this.carInOutLog.pageNum = 1
            this.queryCarInletOutletDetails()
        },
        search(){
            this.pageNum = 1
            this.queryCarInletOutletDetails()
        },
        changePageNum(p){
           this.carInOutLog.pageNum = p.current
           this.queryCarInletOutletDetails() 
        }
    }
}
</script>

<style lang="scss" scoped>
  
</style>